import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function deleteCarts(token: string, quoteIds: string[]): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('deleteCarts')
    .setMethod('POST')
    .setProps([{token: token, quoteIds: quoteIds}])
    .send();
}
